"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkColorStyles = linkColorStyles;
exports.linkStyles = exports.sharedLinkStyles = exports.IconContainer = exports.fontSize = void 0;

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _designTokens = _interopRequireDefault(require("@decisiv/design-tokens"));

var _ConfigProvider = require("../../providers/ConfigProvider");

var _focusRingWithColor = _interopRequireDefault(require("../../utils/focusRingWithColor"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _designTokens$color = _designTokens.default.color,
    base = _designTokens$color.base,
    interaction = _designTokens$color.interaction,
    opacity = _designTokens$color.opacity,
    fontSizes = _designTokens.default.typography.size.alias;
/*
  Notes about changing SVG fill color inside visited links:

  1: Changing the color of a node that contains SVG with nodes set to have
     fill="currentColor" does not work on Safari for :visited links (it does
     work on Chrome and Firefox). To work around that, we instead change the
     fill color of those SVG nodes to be the same color as the visited link.
*/

function linkColorStyles(normalColor, visitedColor, hoverColor, focusColors) {
  var focusStyles = focusColors ? (0, _styledComponents.css)(["&:focus{border-color:", ";", "}"], (0, _toColorString.default)(focusColors.border), (0, _focusRingWithColor.default)((0, _toColorString.default)(focusColors.shadow))) : (0, _styledComponents.css)(["&:focus{border-color:transparent;box-shadow:none;}"]);
  var normalColorString = (0, _toColorString.default)(normalColor);
  var visitedColorString = (0, _toColorString.default)(visitedColor);
  var hoverColorString = (0, _toColorString.default)(hoverColor);
  return (0, _styledComponents.css)(["&:link{color:", ";}", " &:visited,&:visited svg [fill='currentColor']{color:", ";fill:", ";}&:hover,&:hover svg [fill='currentColor']{color:", ";fill:", ";}"], normalColorString, focusStyles, visitedColorString, visitedColorString, hoverColorString, hoverColorString);
}

var modeStateColors = {
  light: {
    normal: interaction.pacificOcean,
    visited: interaction.redWine,
    hover: interaction.indianOcean,
    focus: {
      border: interaction.pacificOcean,
      shadow: interaction.pacificOcean40
    }
  },
  dark: {
    normal: interaction.arcticOcean,
    visited: interaction.roseWine,
    hover: interaction.atlanticOcean,
    focus: {
      border: interaction.arcticOcean,
      shadow: interaction.arcticOcean40
    }
  }
};

var modeColorStyles = function modeColorStyles(mode) {
  var modeColors = modeStateColors[mode];
  return linkColorStyles(modeColors.normal, modeColors.visited, modeColors.hover, modeColors.focus);
};

var invertedColorStyles = function invertedColorStyles() {
  return linkColorStyles(base.snowWhite, _objectSpread({}, base.charcoal, {
    alpha: 0.6
  }), _objectSpread({}, base.snowWhite, {
    alpha: 0.7
  }), {
    border: base.blackSheep,
    shadow: opacity.charcoal40
  });
};

var color = _styledTheming.default.variants(_ConfigProvider.themeKeys.mode, 'variant', {
  normal: {
    light: modeColorStyles('light'),
    dark: modeColorStyles('dark')
  },
  inverted: {
    light: invertedColorStyles(),
    dark: invertedColorStyles()
  }
});

var fontSize = function fontSize(p) {
  var size = (0, _rem.default)(fontSizes[p.size === 'small' ? 'paragraph2' : 'default']);
  return (0, _styledComponents.css)(["font-size:", ";"], size);
};

exports.fontSize = fontSize;
var iconMarginProp = {
  left: 'margin-right',
  right: 'margin-left'
};

var iconMargin = function iconMargin(props) {
  if (props.withText) {
    return "".concat(iconMarginProp[props.position], ": ").concat((0, _rem.default)(5));
  }

  return '';
};

var IconContainer = _styledComponents.default.span.withConfig({
  displayName: "styles__IconContainer",
  componentId: "sc-7854xa-0"
})(["line-height:0;", ";"], iconMargin);

exports.IconContainer = IconContainer;
var sharedLinkStyles = (0, _styledComponents.css)(["background-color:transparent;align-items:baseline;border:1px solid transparent;border-radius:2px;display:inline-flex;text-decoration:underline;transition:none;&:hover{text-decoration:underline;}", ";", "{align-self:center;}"], fontSize, IconContainer);
exports.sharedLinkStyles = sharedLinkStyles;
var linkStyles = (0, _styledComponents.css)(["cursor:pointer;", ";", ";"], color, sharedLinkStyles);
exports.linkStyles = linkStyles;